import {Injectable, Injector} from "@angular/core";
import {SearchModel} from "@fedeltapointofsale/data-client";

/**
 * Search model for Account Type
 */
@Injectable()
export class AccountTypeSearchModel extends SearchModel<any> {
    constructor(injector: Injector) {
        super(injector);
    }

    override getIdentifierField(): string {
        return "id";
    }
}



